import { TYPE_LABELS } from 'lib/constants/transaction/typeLabels';
import { formatDate } from 'lib/helpers/dateUtils';
import { Capitalize, calculateAge } from 'lib/helpers/utility';

import InfoItem from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/components/InvoiceHeader/InfoItem';
import { getAddressDisplay } from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/lib/helpers';
import Dot from 'components/shared/Dot/Dot';

const PatientInformation = ({ id, patient, transaction, lowercase = false, timezone }) => {
  const lowerCaseClassName = lowercase ? '' : 'capitalize';
  const isCheckORCareCredit = transaction?.type === 'check' || transaction?.type === 'care_credit';

  return (
    <div className="flex min-h-36 px-6 py-3.5 sm:px-2">
      <div className="flex flex-1 flex-col">
        <InfoItem value="Billed to" color="neutral-500" className={lowerCaseClassName} />
        <InfoItem value={patient?.f_name + ' ' + patient?.l_name} />
        <div className="flex flex-row flex-wrap items-center gap-1">
          {patient?.id && <InfoItem value={`#${patient?.id}`} color="neutral-700" />}
          {patient?.dob && patient?.id && <Dot size="xs" color="neutral" />}
          {patient?.dob && (
            <>
              <InfoItem value={formatDate(patient?.dob)} color="neutral-700" />
              <Dot size="xs" color="neutral" />
              <InfoItem
                value={`(${calculateAge({ dateOfBirth: patient?.dob })} years)`}
                color="neutral-700"
              />
            </>
          )}
        </div>
        <InfoItem value={getAddressDisplay(patient?.userAddress)} />
        <InfoItem value={patient?.phone} color="neutral-700" />
        <InfoItem value={patient?.email} color="neutral-700" />

        {transaction?.type && (
          <div className="flex flex-col pt-3">
            <InfoItem value="Payment method" color="neutral-500" className={lowerCaseClassName} />
            <InfoItem
              value={TYPE_LABELS[transaction?.type] ?? Capitalize(transaction?.type)}
              color="neutral-700"
            />
          </div>
        )}

        {isCheckORCareCredit && (
          <div className="flex flex-col pt-3">
            <InfoItem value="Note" color="neutral-500" className={lowerCaseClassName} />
            <InfoItem value={transaction?.note} color="neutral-700" />
          </div>
        )}
      </div>
      <div className="flex flex-col items-end justify-end gap-3">
        {id && (
          <div className="flex flex-col items-end">
            <InfoItem value="Receipt ID" color="neutral-500" className={lowerCaseClassName} />
            <InfoItem value={id} color="neutral-700" />
          </div>
        )}
        {transaction?.id && (
          <div className="flex flex-col items-end">
            <InfoItem value="Transaction ID" color="neutral-500" className={lowerCaseClassName} />
            <InfoItem value={transaction?.id} color="neutral-700" />
          </div>
        )}
        {transaction?.created_at && (
          <div className="flex flex-col items-end">
            <InfoItem
              value="Transaction date & time"
              color="neutral-500"
              className={lowerCaseClassName}
            />
            <InfoItem
              color="neutral-700"
              value={formatDate(transaction?.created_at, timezone, 'MM/dd/yyyy h:mm a')}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PatientInformation;
